module.exports = __webpack_public_path__ + "img/7类2级.d1fa9f49.webp";